const baseUrl = 'https://xxxxx.com/api'

export {
    baseUrl
}

